module.exports = __webpack_public_path__ + "img/gb962.prt.f2c916fe.jpg";